/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardProfitView_commissionSummary = ReadonlyArray<{
    readonly spoke: {
        readonly account: string;
    };
    readonly current: {
        readonly realTime: number;
        readonly monthEnd: number;
        readonly cash: number;
        readonly total: number;
    };
    readonly " $refType": "DashboardProfitView_commissionSummary";
}>;
export type DashboardProfitView_commissionSummary$data = DashboardProfitView_commissionSummary;
export type DashboardProfitView_commissionSummary$key = ReadonlyArray<{
    readonly " $data"?: DashboardProfitView_commissionSummary$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardProfitView_commissionSummary">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "DashboardProfitView_commissionSummary",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "spoke",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "account",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfitCommission",
      "kind": "LinkedField",
      "name": "current",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "realTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "monthEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cash",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CommissionSummary",
  "abstractKey": null
};
(node as any).hash = '1d74a5da7f2992c9fd41393f32abbc4f';
export default node;
